import Repeat from './Repeat/Repeat';
import { types } from './types';

function Actions(action, showAlert ,variables, setOpenVariable, variableRender) {
    if (action.actionName === types.REPEAT) {
        return <Repeat action={action} inputName="loop" variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender} />;
    }
}

export default Actions;
